<template>
    <div class="column center aligned pointer setting_group">
        <div class="box"
            @click="set_settings()"
            :style="{
                margin: '0 auto',
                backgroundColor: setting_group.color
            }">

            <!-- <img class="sprite"
                :src="'/images/barcode_setting_group_icons/'+setting_group.icon_file_name+'.svg'"> -->

            <i class="huge icons" style="margin: 5px;" >
                <i :class="setting_group.primary_icon_classes"></i>
                <i :class="setting_group.secondary_icon_classes || 'right bottom corner icon'"></i>
            </i>
            <!-- <i  style="margin: 5px;" :class="setting_group.primary_icon_classes" v-else></i> -->

            <p class="mobile only"
                :style="{fontSize: content_font_size + 'px' }">
                {{ setting_group.name || '-' }}
            </p>
            <p class="computer only">
                {{ setting_group.name || '-' }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        setting_group: Object,
    },
    data() {
        return {
            content_font_size: this.calculate_content_font_size(),
        }
    },
    computed: {
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        calculate_content_font_size() {
            var length = this.setting_group.name.length
            return (length > 4) ? 17 : ''
        },
        set_settings() {
            this.$bus.$emit(
                'quick_setting_number',
                `@@${this.setting_group.key}@@`,
                false,
                false
            )
        },
    },
    components: {
    },
}
</script>

<style lang="scss" scoped>
    .setting_group {
        .sprite {
            margin: 0 auto;
            max-width: 50px
        }
        p {
            font-size: 120%;
        }
    }

    $mobile_box_size: 120px;

    @media only screen and (max-width: 767px) {
        .column.setting_group {
            // .box {
            //     height: $mobile_box_size;
            //     width: $mobile_box_size;
            //     margin: 0 auto;
            //     padding: 6px 0;
            // }
            .sprite {
                max-width: 80px
            }
        }
    }
    @media only screen and (max-width: 320px) {
        .column.setting_group {
            p {
                font-size: 4vh;
            }
        }
    }
</style>
